import { createActions } from '@play-co/replicant';

import { stateSchema } from 'src/replicant/State';
import computedProperties from 'src/replicant/computedProperties';
import messages from 'src/replicant/messages';
import scheduledActions from 'src/replicant/scheduledActions';
import ab from 'src/replicant/ruleset/ab';

export default createActions(stateSchema, {
  computedProperties,
  messages,
  scheduledActions,
  ruleset: { abTests: ab.dynamicAB },
});
